import {GritCondition, GritConditionType} from "./grit.filter";
import {GritInputCondition, GritModel, GritOption, GritTableField} from "./grit.model";
import {GritDynamicTableType} from "./grit.enums";
import {PowerField} from "./grit.variable-unit-fields";

export class ReceiverModel implements GritModel<ReceiverModel> {
  id: number = 0;

  groupVisibility: string = "";
  groupAccess: string = "";
  groupOriginator: string = "";

  name: string = "";
  threshold: PowerField = new PowerField(0);
  gain: number = 0;

  deviceType : string = "";
  calculationUse : boolean = false;

  public toDTO() {
    return {
      id: this.id,

      groupVisibility: this.groupVisibility,
      groupAccess: this.groupAccess,
      groupOriginator: this.groupOriginator,

      name: this.name,
      threshold: this.threshold.dBW,
      gain: this.gain,

      deviceType: this.deviceType,
      calculationUse: this.calculationUse,
    }
  }

  public fromDTO(deviceDTO: any) {
    this.id = deviceDTO.id;

    this.groupVisibility = deviceDTO.groupVisibility;
    this.groupAccess = deviceDTO.groupAccess;
    this.groupOriginator = deviceDTO.groupOriginator;

    this.name = deviceDTO.name;
    this.threshold.dBW = deviceDTO.threshold;
    this.gain = deviceDTO.gain;

    this.deviceType = deviceDTO.deviceType;
    this.calculationUse = deviceDTO.calculationUse;

    return this;
  }

  //#region JSON
  public exportJson(){
    return {
      name: this.name,
      threshold: this.threshold.dBW,
      gain: this.gain,

      deviceType: this.deviceType,
      calculationUse: this.calculationUse,
    }
  }

  public importJson(obj: any, group: string){
    this.groupVisibility = group;
    this.groupAccess = group;
    this.groupOriginator = group;

    this.name = obj.name;
    this.threshold.dBW = obj.threshold;
    this.gain = obj.gain;

    this.deviceType = obj.deviceType;
    this.calculationUse = obj.calculationUse;

    return this;
  }
  //endregion

  identifyToolOutput(){
    return `
        <h5 style="font-weight:bold">Receiver</h5>
        <p>Name: ${this.name}</p>
        <p>Threshold: ${this.threshold}</p>
        <p>Gain: ${this.gain}</p>
        `
  }

  static fieldsValues: Record<string, GritOption<string>[]> = {}

  static configuration: Record<string, GritOption<any>[]> = {
    table: [
      {
        display: "Name",
        value: {
          type: GritDynamicTableType.BASIC,
          fieldValue : function (entity: ReceiverModel) {
            return entity.name;
          }
        }
      },
      {
        display: "Type",
        value: {
          type: GritDynamicTableType.BASIC,
          fieldValue : function (entity: ReceiverModel) {
            return String(entity.deviceType);
          }
        }
      },
      {
        display: "Threshold[dBW]",
        value: {
          type: GritDynamicTableType.BASIC,
          fieldValue : function (entity: ReceiverModel) {
            return String(entity.threshold.dBW);
          }
        }
      },
      {
        display: "Gain[dBI]",
        value: {
          type: GritDynamicTableType.BASIC,
          fieldValue : function (entity: ReceiverModel) {
            return String(entity.gain);
          }
        }
      },
      {
        display: "Use",
        value: {
          type: GritDynamicTableType.BASIC,
          fieldValue : function (entity: ReceiverModel) {
            return entity.calculationUse ? 'Yes': 'No';
          }
        }
      },
    ] as GritOption<GritTableField<ReceiverModel>>[],

    filters: [] as GritOption<GritInputCondition>[],

    search: [
      {
        display: "All",
        value: {
          inputs: [],
          condition: function (values: string[]): GritCondition[] {
            let condition = new GritCondition("name", GritConditionType.StartsWith, "");
            return [condition]
          }
        }
      },
      {
        display: "Name",
        value: {
          inputs: [
            {
              field: "Starts With",
              type: "text",
              value: () => "",
            },
          ],
          condition: function (values: string[]): GritCondition[] {
            let condition = new GritCondition("name", GritConditionType.StartsWith, values[0]);
            return [condition]
          }
        }
      },
      {
        display: "Latitude",
        value: {
          inputs: [
            {
              field: "Starts With",
              type: "text",
              value: () => "",
            },
          ],
          condition: function (values: string[]): GritCondition[] {
            let condition = new GritCondition("latitude.value", GritConditionType.StartsWith, values[0]);
            return [condition]
          }
        }
      },
      {
        display: "Longitude",
        value: {
          inputs: [
            {
              field: "Starts With",
              type: "text",
              value: () => "",
            },
          ],
          condition: function (values: string[]): GritCondition[] {
            let condition = new GritCondition("longitude.value", GritConditionType.StartsWith, values[0]);
            return [condition]
          }
        }
      },
      {
        display: "Threshold",
        value: {
          inputs: [
            {
              field: "Starts With",
              type: "text",
              value: () => "",
            },
          ],
          condition: function (values: string[]): GritCondition[] {
            let condition = new GritCondition("threshold", GritConditionType.StartsWith, values[0]);
            return [condition]
          }
        }
      },
      {
        display: "Gain",
        value: {
          inputs: [
            {
              field: "Starts With",
              type: "text",
              value: () => "",
            },
          ],
          condition: function (values: string[]): GritCondition[] {
            let condition = new GritCondition("gain", GritConditionType.StartsWith, values[0]);
            return [condition]
          }
        }
      },
    ] as GritOption<GritInputCondition>[]
  }
}
